import React, { useMemo } from 'react';
import parse, { attributesToProps } from 'html-react-parser';
import Icon from './Icon';

const options = {
    replace(node) {
        const classes = (node.attribs?.class || '').split(/\s+/);
        if (!classes.includes('material-symbols-rounded')) return;

        const name = (node.children || []).map(child => child.data || '').join('').trim();
        if (!/^[a-z0-9_]+$/.test(name)) return;

        // Keep the original element's classes/styles and sibling order so that
        // the quiz label's sizes and nth-child opacity rules remain unchanged.
        const props = attributesToProps(node.attribs);
        props.className = classes.filter(value => value !== 'material-symbols-rounded').join(' ');
        return <Icon {...props} name={name} />;
    },
};

// For the same trusted CMS HTML previously rendered via dangerouslySetInnerHTML.
// Convert icon names before the first paint; unknown names use Icon's font fallback.
export default function HtmlWithIcons({ html = '' }) {
    const content = useMemo(() => parse(html || '', options), [html]);
    return <>{content}</>;
}
